import request from '../utils/http'
const appid =  2006  // 不同小程序对接同一后台
const QYGUID = '2bebde7d9540434aa629d5844595eaf7'; // 企业guid

// 198 获取当前用户基本信息
export function getUserInfo(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getuser',
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 203 登录
export function login(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "login",
            appid,
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 202 注册
export function register(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "reg",
            appid,
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 发送手机号 280
export function sendVerfity(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'sms',
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}


// 获取省市 57
export function getProvince() {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'area'
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 获取城市 58
export function getCity(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'city',
            areaid: id
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 获取区域 286
export function getArea(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addr',
            cityid: id
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 205 修改用户信息
export function updateUserInfo(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_shop_user_edit",
            ...data 
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
        
    })
}

// 修改用户扩展信息 143
export function updateUserExtInfo(data) {
    return request({
        url: "/service/farming.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_farming_user_ext_edit",
            ...data 
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 图片上传 228
export function uploadImage(data) {
    return request({
        url: "/service_app/ImageUpload.ashx",  //接口路径
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data,
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 65 提交退费
export function submitRefund(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        params: {
            Method: 'addbacklog',
            appid,
            qyguid: QYGUID,
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

// 226 分页获取用户列表
export function getUserList(data) {
    return request({
        url: "/service/sumlist.ashx",  //接口路径
        method: "get",  //接口方法
        params: {
            Method: 'LoadPagedams_shop_user',
            appid: 10022,
            ...data
        },
        // 添加自定义标记，表明该请求使用公共接口域名
        isPublicApi: true
    })
}

